import { useState } from 'react';
import styles from './CustomerSupportPagerDutyAppInfo.module.css';
import { Icon } from '@bookingcom/bui-react';
import { InfoSignIcon } from '@bookingcom/bui-assets-react/streamline';

const CustomerSupportPagerDutyAppInfo = () => {
  const [seeMoreButtonContent, setSeeMoreButtonContent] = useState(false);
  return (
    <>
      <div className={styles.pagerDutyAppInfoContainer} data-testid={'appInfoDivTestId'}>
        <div className={styles.pagerDutyAppInfoSignMainContainer}>
          <Icon svg={InfoSignIcon} size={'large'} color="brand_genius_secondary" />
          <div className={styles.pagerDutyAppInfoContantContainer}>
            <p>
              <strong>{' What if the panic button page is not working?'}</strong>
            </p>
            {seeMoreButtonContent && (
              <p className={styles.alertInfo}>You can fallback to the following approaches:</p>
            )}
            {seeMoreButtonContent && (
              <ul>
                <li>
                  You can manually trigger a pager duty incident using the following link :{' '}
                  <a
                    href={import.meta.env.VITE_APP_PAGERDUTY_CREATE_INCIDENT_URL}
                    style={{ color: 'blue', cursor: 'pointer' }}
                    target={'_blank'}
                    rel="noopener noreferrer">
                    link
                  </a>
                  .
                </li>
                <li>
                  Guide :{' '}
                  <a
                    href={import.meta.env.VITE_APP_PAGERDUTY_CREATE_INCIDENT_GUIDE_URL}
                    style={{ color: 'blue', cursor: 'pointer' }}
                    target={'_blank'}
                    rel="noopener noreferrer">
                    document
                  </a>
                  .
                </li>
              </ul>
            )}
          </div>
        </div>
        <button
          className={styles.pagerDutyAppSeeMoreButton}
          onClick={() => setSeeMoreButtonContent(!seeMoreButtonContent)}>
          {seeMoreButtonContent ? 'Show less' : 'Show More'}
        </button>
      </div>
    </>
  );
};

export default CustomerSupportPagerDutyAppInfo;
